'use client';
import React from 'react';
import { LogoCarousel as SharedLogoCarousel } from '@launchstore/shared-puck';

export const LogoCarousel: any = SharedLogoCarousel;
export default LogoCarousel;
